import { PaymentProcessDialog } from './payment-process-dialog';
import { DIALOG } from '../dialog-combiner';
import { transitions } from '../transition.config';
import { userModals } from 'core/User/modal.config';

DIALOG.add(userModals.PAYMENT_PROCESS, {
  component: PaymentProcessDialog,
  transition: transitions.SCALABLE,
  anchor: 'portal',
});
